export enum ParticularColorType {
  Palette = 'palette',
  Custom = 'custom',
}
